import { shellAssets } from '../../constants/assets'
import { navSections } from '../../data/navigation'
import { NavPanelItem } from './NavPanelItem'
import { useDashboardBadges } from '../../context/DashboardBadgeContext'

type NavPanelProps = {
  activeId: string
  onSelect?: (id: string) => void
  onToggle?: () => void
}

/** The expanded sidebar: one white card listing every destination with its label. */
export const NavPanel = ({ activeId, onSelect }: NavPanelProps) => {
  const { hasNewEnquiry, hasNewNotification } = useDashboardBadges()

  const dynamicNavSections = navSections.map((section) => ({
    ...section,
    items: section.items.map((item) => {
      if (item.id === 'enquiries') {
        return { ...item, badge: hasNewEnquiry ? ('dot' as const) : undefined }
      }
      if (item.id === 'notifications') {
        return { ...item, badge: hasNewNotification ? ('dot' as const) : undefined }
      }
      return item
    }),
  }))

  return (
    <div
  className="flex h-[calc(100dvh-74px)] max-h-[772px] w-[213px] flex-col items-center overflow-hidden rounded-[21px] bg-white px-[20px] shadow-dash-panel-nav"
  style={{
  paddingTop: 'clamp(12px, 2.5vh, 19px)',
  paddingBottom: 'clamp(22px, 3vh, 26px)',
}}
>
      <div
  className="flex w-full flex-col items-center"
  style={{ gap: 'clamp(30px, 6vh, 47px)' }}
>
        <div className="flex w-full flex-col items-center gap-[47px]">
          <img
            alt="Salzburg Cab"
            className="block h-[44px] w-[88px] max-w-none shrink-0 object-cover"
            src={shellAssets.logo}
          />

          <nav
  aria-label="Dashboard"
  className="flex w-full flex-col items-start"
  style={{ gap: 'clamp(22px, 4vh, 31px)' }}
>
            {dynamicNavSections.map((section) => (
              <div
                key={section.id}
                className="flex w-full flex-col items-center"
                style={{
  gap:
    section.id === 'menu'
      ? 'clamp(15px, 2.2vh, 18px)'
      : `min(${section.headingGap}px, 3vh)`,
}}
              >
                <p className="w-full font-host text-[12px] font-normal leading-[14.217px] text-black">
                  {section.label}
                </p>

                <div
                  className="flex flex-col items-start"
                  style={{
  gap:
    section.id === 'menu'
      ? 'clamp(16px, 2.35vh, 20px)'
      : `min(${section.rowGap}px, 3vh)`,
  width: section.listWidth,
}}
                >
                  {section.items.map((item) => (
                    <NavPanelItem
                      key={item.id}
                      item={item}
                      active={item.id === activeId}
                      onSelect={onSelect}
                    />
                  ))}
                </div>
              </div>
            ))}
          </nav>
        </div>
      </div>
    </div>
  )
}
